import { SanitizedFormattedHtmlMessageProps } from '@atlassiansox/bxpkit-core';

type SharedFormDataType = {
  readonly goToProductUrl: string;
  readonly submitErrorMessage?: SanitizedFormattedHtmlMessageProps;
  readonly resendEmailAddress: string;
};

type SharedFormDataActionType = {
  readonly type: string;
  readonly payload?: Partial<SharedFormDataType> | SharedFormDataType;
};

// Actions
const UPDATE_GOTO_PRODUCT_URL = 'shared-form-data/UPDATE_GOTO_PRODUCT_URL';
const UPDATE_SUBMIT_ERROR_MESSAGE =
  'shared-form-data/UPDATE_SUBMIT_ERROR_MESSAGE';
const UPDATE_RESEND_EMAIL_ADDRESS =
  'shared-form-data/UPDATE_RESEND_EMAIL_ADDRESS';
// Initial State
const initialState: SharedFormDataType = {
  goToProductUrl: '',
  submitErrorMessage: undefined,
  resendEmailAddress: ''
};

// Reducer
export const sharedFormDataReducer = (
  state = initialState,
  action: SharedFormDataActionType
): SharedFormDataType => {
  switch (action.type) {
    case UPDATE_GOTO_PRODUCT_URL:
      return {
        ...state,
        goToProductUrl: action.payload?.goToProductUrl || ''
      };
    case UPDATE_SUBMIT_ERROR_MESSAGE:
      return {
        ...state,
        submitErrorMessage: action.payload?.submitErrorMessage
      };
    case UPDATE_RESEND_EMAIL_ADDRESS:
      return {
        ...state,
        resendEmailAddress: action.payload?.resendEmailAddress || ''
      };
    default:
      return state;
  }
};

// Action Creators
export function updateSharedFormDataGoToProductUrl(
  goToProductUrl: string
): SharedFormDataActionType {
  return {
    type: UPDATE_GOTO_PRODUCT_URL,
    payload: {
      goToProductUrl
    }
  };
}

export function updateSharedFormDataResendEmailAddress(
  resendEmailAddress: string
): SharedFormDataActionType {
  return {
    type: UPDATE_RESEND_EMAIL_ADDRESS,
    payload: {
      resendEmailAddress
    }
  };
}

export function updateSharedFormDataSubmitErrorMessage(
  submitErrorMessage: undefined | SanitizedFormattedHtmlMessageProps
): SharedFormDataActionType {
  return {
    type: UPDATE_SUBMIT_ERROR_MESSAGE,
    payload: {
      submitErrorMessage
    }
  };
}
